import {connect} from 'react-redux';
import Routes from '../../components/Routes/Routes';
import {IReduxStoreState} from '../../@interfaces';

export default connect((state: IReduxStoreState) => ({...state.routes}))(Routes);
